"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconDeliveryLoad = function SvgIconDeliveryLoad(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "delivery load icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Delivery Load Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.75 11.633a.382.382 0 01-.112-.271V6.383A.382.382 0 0119.021 6h2.428c.612 0 1.198.242 1.632.673l4.407 4.418a.383.383 0 01-.271.654h-8.196c-.101 0-.2-.04-.271-.112zm13.293 10.452c5.496.007 9.95 4.461 9.957 9.958C42 37.542 37.542 42 32.043 42c-5.5 0-9.958-4.458-9.958-9.957 0-5.423 4.335-9.834 9.729-9.955l.229-.003zm4.787 6.368a1.149 1.149 0 00-1.538.145l-.07.085-4.186 5.58a.383.383 0 01-.525.084l-.05-.042-1.992-1.991a1.148 1.148 0 00-1.962.815c0 .267.095.525.264.729l.077.084 2.298 2.298c.394.396.918.633 1.472.67l.152.006h.163a2.28 2.28 0 001.581-.8l.095-.12 4.45-5.934a1.149 1.149 0 00-.23-1.609zM15.957 11.745a.383.383 0 00.383-.383V6.383A.383.383 0 0015.957 6h-2.43c-.61 0-1.196.242-1.63.673L7.485 11.09a.383.383 0 00.278.654h8.195zm13.022 8.153a.384.384 0 01-.28.369 12.274 12.274 0 00-8.765 9.919.381.381 0 01-.377.325H8.297A2.298 2.298 0 016 28.213V14.425a.381.381 0 01.383-.382h22.213c.211 0 .383.171.383.383v5.472z"
  }));
};

var _default = SvgIconDeliveryLoad;
exports.default = _default;